module.exports = __webpack_public_path__ + "img/RBS_event_01.4b2504d8.png";